// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1oJmv","errorLogs":"EditorFooter_errorLogs__11Jgb"};